import { compare, Guard } from "lib/actions/util";
import { Moment } from "moment";

export function maxBy<T>(
  iterable: Iterable<T>,
  selector: (item: T) => number | string | Date | Moment,
): T | undefined {
  Guard.require(selector, "selector");
  if (!iterable) return undefined;
  let max: T | undefined = undefined,
    maxSelected: ReturnType<typeof selector> | undefined = undefined;
  for (const item of iterable) {
    const selected = selector(item);
    if (max === undefined || compare(selected, maxSelected) > 0) {
      max = item;
      maxSelected = selected;
    }
  }
  return max;
}
